import { getLocalStorageItem } from './localStorage';
import { removeModalQuery } from './removeModalQuery';

export const getAddressLink = (searchQuery, address, query) => {
	const companyId = getLocalStorageItem('user_data').companyId;

	let link;
	let fromLink = '';

	if (query) {
		if (query.has('modal')) {
			fromLink += `&fromModal=${query.get('modal')}`;

			if (query.has('id')) {
				fromLink += `&fromId=${query.get('id')}`;
			}
		}
	}

	const search = removeModalQuery(searchQuery);

	if (companyId === address?.partner_id) {
		link = `?${search ? `${search}&` : ''}modal=address&id=${address?.id}${fromLink}`;
	} else {
		link = `?${search ? `${search}&` : ''}modal=address&addressId=${address?.id}&id=${
			address?.partner_id
		}${fromLink}`;
	}

	return {
		...address,
		link,
	};
};
